import { ProximityReader } from 'capacitor-proximity-reader';
import { isIOS } from './capacitor';
import { recordTapToPayDiagnostic } from './tapToPay';

/**
 * Merchant education for Tap to Pay on iPhone (App Review checklist §4).
 *
 * Prefers Apple's own `ProximityReaderDiscovery` screens: the checklist says using
 * them fulfils requirements 4.4, 4.6, 4.7 and 4.8 outright, and Apple keeps the
 * content localized and current. They are iOS 18+, so `showTapToPayEducation`
 * reports whether it managed to present them — a `false` return means the caller
 * should show the in-app fallback instead.
 */
export async function showTapToPayEducation(): Promise<boolean> {
    if (!isIOS()) return false;

    try {
        const { presented } = await ProximityReader.presentEducation();
        recordTapToPayDiagnostic('education', 'Apple Tap to Pay education screens', { presented });
        return presented;
    } catch (err: any) {
        // Never block setup on education failing — the fallback screen covers it.
        recordTapToPayDiagnostic('education', 'Apple education screens unavailable', {
            error: err?.message ?? String(err),
        }, 'warn');
        return false;
    }
}
